import { render } from "./BuildReceiptTemplate.vue?vue&type=template&id=33052c48"
import script from "./BuildReceiptTemplate.vue?vue&type=script&lang=js"
export * from "./BuildReceiptTemplate.vue?vue&type=script&lang=js"

import "./BuildReceiptTemplate.vue?vue&type=style&index=0&id=33052c48&slot-scope=true&lang=css"
import "./BuildReceiptTemplate.vue?vue&type=style&index=1&id=33052c48&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__